import { snakeCase, isPlainObject, reduce, isArray } from 'lodash';

export const toSnakeCase = object => {
  // Convert deep nested object and arrays keys
  if (!isPlainObject(object) && !isArray(object)) {
    return object;
  } else if (isArray(object)) {
    return object.map(v => toSnakeCase(v));
  }
  return reduce(
    object,
    (r, v, k) => {
      return {
        ...r,
        [snakeCase(k)]: toSnakeCase(v)
      };
    },
    {}
  );
};
